// extracted by mini-css-extract-plugin
export default {"element":"StoreDisplayName__element___tV06D"};